module.exports = __webpack_public_path__ + "static/opt_x1.5d667c40.png";